import axios from 'axios';
import { host } from '../../utils/config';

let axiosInstance = null;

export const useAxios = () => {
  const getHost = () => {
    if (process.env.NODE_ENV === 'development') {
      // return 'http://localhost:8080';
      return host;
    }
    return host;
    // return '';
  };

  function getTenantIdentifier() {
    const full = window.location.host;
    // window.location.host is subdomain.domain.com
    const parts = full.split('.');
    if (parts.length === 3) return parts[0];
    return 'localhost';
  }

  if (!axiosInstance) {
    axiosInstance = axios.create({
      baseURL: getHost(),
      headers: { Authorization: localStorage.getItem('userToken') },
    });
  }

  return axiosInstance;
};
